/**
 * Vocabulário único do veredito exposto ao usuário (E59 — rodada 3, item 2). // ux-neutrality:allow doc-comment
 *
 * Antes desta Etapa conviviam três vocabulários na tela: a triagem falava // ux-neutrality:allow doc-comment
 * de compatibilidade, o portal usava o par que esta Etapa aposentou e a // ux-neutrality:allow doc-comment
 * fila do certificador repetia o do portal com chaves próprias. Cada tela tinha // ux-neutrality:allow doc-comment
 * o seu mapa e o seu tom — três lugares para divergir. // ux-neutrality:allow doc-comment
 * // ux-neutrality:allow doc-comment
 * Agora há UM: todo estado de domínio passa por aqui e sai como convergente, // ux-neutrality:allow doc-comment
 * divergente ou inconclusivo, com o tom do semáforo junto. // ux-neutrality:allow doc-comment
 * // ux-neutrality:allow doc-comment
 * **O que NÃO muda** (decisão do owner, 2026-07-30): a conclusão verbal do // ux-neutrality:allow doc-comment
 * laudo continua na escala forense (compatibilidade/incompatibilidade) e os // ux-neutrality:allow doc-comment
 * valores gravados no banco continuam como estão. A troca é de EXIBIÇÃO — é o // ux-neutrality:allow doc-comment
 * dual naming: nome de domínio e nome de tela são coisas separadas. // ux-neutrality:allow doc-comment
 */
import { ptBR } from '@/i18n/pt-BR';

/**
 * Estado do domínio da triagem (espelha `TendenciaDaTriagem` do backend).
 *
 * Binário desde a E100.F1 (GUS-64). `ResultadoDominio` logo abaixo **continua**
 * com `inconclusivo`, e não é inconsistência: quem o produz é a raia eletrônica,
 * onde o estado é determinístico e tem causa nomeável (ADR-0084 §4).
 */
export type TendenciaDominio = 'compatibilidade' | 'divergencia';

/** Estado do domínio do exame primário (espelha `ResultadoExameCcb`). */
export type ResultadoDominio = 'favoravel' | 'inconclusivo' | 'desfavoravel' | 'em_exame';

/**
 * O vocabulário único. `pendente` não é veredito — é a ausência dele, e existe // ux-neutrality:allow doc-comment
 * porque o exame ainda em curso precisa de um estado próprio em vez de ser // ux-neutrality:allow doc-comment
 * empurrado para inconclusivo, que já significa outra coisa. // ux-neutrality:allow doc-comment
 */
export type Veredito = 'convergente' | 'divergente' | 'inconclusivo' | 'pendente';

/** Tom do semáforo: status de UI, fora da identidade visual do produto. */
export type TomVeredito = 'success' | 'danger' | 'warning' | 'info';

const TENDENCIA_PARA_VEREDITO: Record<TendenciaDominio, Veredito> = {
  compatibilidade: 'convergente',
  divergencia: 'divergente',
};

const RESULTADO_PARA_VEREDITO: Record<ResultadoDominio, Veredito> = {
  favoravel: 'convergente',
  desfavoravel: 'divergente',
  inconclusivo: 'inconclusivo',
  em_exame: 'pendente',
};

export const VEREDITO_ROTULO: Record<Veredito, string> = {
  convergente: ptBR.veredito.convergente,
  divergente: ptBR.veredito.divergente,
  inconclusivo: ptBR.veredito.inconclusivo,
  pendente: ptBR.veredito.pendente,
};

export const VEREDITO_TOM: Record<Veredito, TomVeredito> = {
  convergente: 'success',
  divergente: 'danger',
  inconclusivo: 'warning',
  pendente: 'info',
};

export function vereditoDaTendencia(tendencia: TendenciaDominio): Veredito {
  return TENDENCIA_PARA_VEREDITO[tendencia];
}

export function vereditoDoResultado(resultado: ResultadoDominio): Veredito {
  return RESULTADO_PARA_VEREDITO[resultado];
}

export function rotuloDoResultado(resultado: ResultadoDominio): string {
  return VEREDITO_ROTULO[vereditoDoResultado(resultado)];
}

export function tomDoResultado(resultado: ResultadoDominio): TomVeredito {
  return VEREDITO_TOM[vereditoDoResultado(resultado)];
}

export function rotuloDaTendencia(tendencia: TendenciaDominio): string {
  return VEREDITO_ROTULO[vereditoDaTendencia(tendencia)];
}
